import './SpaceBetweenLayout.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps extends PropsWithChildren {
  className?: string;
  wrap?: boolean;
}

export const SpaceBetweenLayout = ({ children, className, wrap }: IProps): ReactElement => (
  <div className={classNames('space-between-layout', className, { wrap })}>{children}</div>
);
